import React, { PureComponent } from 'react'
import { Route, Switch, Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import BEMHelper from '@ynap/bem-helper'
import EmailPasswordTokenForm from '../EmailPasswordTokenForm/EmailPasswordTokenForm'
import ResetPasswordForm from '../ResetPasswordForm/ResetPasswordForm'
import { parse } from 'query-string'
const bem = new BEMHelper('ForgotPassword')

export default class ForgotPassword extends PureComponent {
    static propTypes = {
        messages: PropTypes.shape({
            forgotPassword: PropTypes.shape({
                cancel: PropTypes.func.isRequired,
            }).isRequired,
        }),
        config: PropTypes.object,
        locale: PropTypes.shape({
            id: PropTypes.string,
        }).isRequired,
        className: PropTypes.string,
        resetPasswordEmail: PropTypes.func.isRequired,
        resetPassword: PropTypes.func.isRequired,
        login: PropTypes.func.isRequired,
        noUppercaseLangs: PropTypes.array,
    }

    render() {
        const {
            config,
            messages,
            locale,
            resetPasswordEmail,
            resetPassword,
            login,
            className,
            noUppercaseLangs,
        } = this.props

        return (
            <div className={bem(null, null, className)}>
                <Switch>
                    <Route
                        path="/:locale/account/forgot-password/reset"
                        render={(matchProps) => {
                            const { email: logonId, validationCode } = parse(matchProps.location.search)
                            return (
                                <ResetPasswordForm
                                    config={config}
                                    messages={messages}
                                    locale={locale}
                                    initialValues={{ logonId, validationCode }}
                                    onSubmit={(credentials, delay) => resetPassword(credentials, delay, 'account')}
                                    login={login}
                                    noUppercaseLangs={noUppercaseLangs}
                                    loginRedirect="account"
                                />
                            )
                        }}
                    />
                    <Route
                        render={() => (
                            <EmailPasswordTokenForm
                                config={config}
                                messages={messages}
                                onSubmit={resetPasswordEmail}
                                locale={locale}
                            >
                                <Link className={bem('cancel')} to={`/${locale.id}/account/login`}>
                                    {messages.forgotPassword.cancel()}
                                </Link>
                            </EmailPasswordTokenForm>
                        )}
                    />
                </Switch>
            </div>
        )
    }
}
